if (!customElements.get('share-space-featured')) {
  class ShareSpaceFeatured extends HTMLElement {
    constructor() {
      super();
      this.currentPage = 0;
    }

    connectedCallback() {
      this.grid = this.querySelector('[data-grid]');
      this.cards = Array.from(this.grid.children);
      this.prevBtn = this.closest('section').querySelector('[data-prev]');
      this.nextBtn = this.closest('section').querySelector('[data-next]');

      if (this.prevBtn && this.nextBtn) {
        this.prevBtn.addEventListener('click', () => this._navigate(-1));
        this.nextBtn.addEventListener('click', () => this._navigate(1));
      }

      this._checkMobile();
      window.addEventListener('resize', () => this._checkMobile());
    }

    _checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    }

    _navigate(dir) {
      if (this.isMobile) return;

      const pageSize = 3;
      const totalPages = Math.ceil(this.cards.length / pageSize);
      this.currentPage = (this.currentPage + dir + totalPages) % totalPages;

      this.cards.forEach((card, i) => {
        const inPage =
          i >= this.currentPage * pageSize &&
          i < (this.currentPage + 1) * pageSize;
        card.style.display = inPage ? '' : 'none';
      });
    }
  }

  customElements.define('share-space-featured', ShareSpaceFeatured);
}
